import React from "react";
import "./Home.css";
import Banner from "../banner/Banner";
import Feature from "../feature/Feature";
import Note from "../note/Note";
import Accordion from "../accordion/Accordion";
import Focus from "../focus/Focus";
import Popular from "../popular/Popular";
import Popular1 from "../popular/Popular1";
import Customer from "../customer/Customer";
import Join from "../join/Join";
import Contact from "../contact/Contact";
import Footer from "../footer/Footer";

const Home = () => {
  return (
    <div className="">
      <Banner></Banner>
      <Feature></Feature>
      <Note></Note>
      <Accordion></Accordion>
      <Focus></Focus>
      <Popular></Popular>
      <Popular1></Popular1>
      <Customer></Customer>
      <Join></Join>
      <Contact></Contact>
      <Footer></Footer>
    </div>
  );
};

export default Home;
